export default{
    state:{
        // 资产分类
        leaseTypeName: {
            'SHOP':'商铺',
            'HOME':'住宅',
            'MARKET':'市场',
            'FACTORY_BUILDING':'厂房',
            'OFFICE':'办公',
            'LAND':'土地',
            'SITE':'场地',
            'AGRICULTURAL_LAND':'农用地',
            'BUSINESS':'商业',
            'OTHER':'其他',
        },
        // 资产类别
        leaseAreaTypeName:{
            "STATE_OWNED_ASSETS":'区属国有资产',
            "DISTRICT_COLLECTIVE_ASSETS":'区属集体资产',
            "TOWNSHIP_COLLECTIVE_ASSETS":'镇属集体资产',
            "TOWNSHIP_OWNED_ASSETS":'镇属国有资产',
            "STATE_ASSETS":'国有资产',
            "VILLAGE_OWNED_ASSETS":'村属集体资产',
            "COMPANY_ASSETS":'企业资产',
            "PERSON_ASSETS":'个人资产',
            "OTHER_ASSETS":'其他',
        }
    },
    mutations:{},
    actions:{}
}